import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Word } from 'src/app/models/word.model';

@Component({
  selector: 'app-word-detail',
  templateUrl: './word-detail.component.html',
  styleUrls: ['./word-detail.component.css']
})
export class WordDetailComponent implements OnInit {

  @Input() showShimmer: boolean;
  @Input() word: Word;

  constructor() { }

 

  ngOnInit(): void {

  }


}
